import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Amplify from 'aws-amplify';
import React, { Component } from 'react';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Auth } from 'aws-amplify';
import * as Icon from 'react-feather';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import { Query } from "react-apollo";
import DASHBOARD_QUERY from './Dashboard/GQLQueries';
//import DASHBOARD_QUERY from '/../GQLQueries';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import _ from 'lodash';
// import { Auth } from "aws-amplify";
import * as CONFIG from "../api/config";
const { createApolloFetch } = require("apollo-fetch");

class Sidemenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_groups: [],
      is_back_office_profession_register: false,
      open: true,
      auth: true,
      anchorEl: null,
      loginMenuItem: 'Logout',
      user_name: undefined
    }
    this.GetUserName();
    this.verifyUserRights('100');
    this.GetUserName = this.GetUserName.bind(this);
  }
  async GetUserName() {
    let userInfo = await Auth.currentAuthenticatedUser();
    console.log('sidemenu userInfo=>', userInfo);
    this.setState({
      user_name: userInfo.username
    });
  }

  async componentWillMount() {
    try {
      const userInfo = await Auth.currentSession();
      let user_groups = userInfo.idToken.payload["cognito:groups"] ? userInfo.idToken.payload["cognito:groups"] : [];
      let is_back_office_profession_register = _.find(user_groups, function (group) { return _.includes(group, 'back-office-profession-register') }) ? true : false;
      this.setState({ user_groups, is_back_office_profession_register });
    }
    catch (ex) { }
  }

  handleLogout = async () => {
    try {
      localStorage.removeItem('profession');
      await Auth.signOut();
    }
    catch (ex) { }
    // this.props.history.push("/signout");
    //   Auth.signOut().then(() => {
    //   console.log('signedOut');
    // }).catch(err => {
    //   console.log(err);
    //   this.error(err);
    // });
    this.setState({ anchorEl: null, loginMenuItem: 'Login', });
  }


  async verifyUserRights(apn_type) {
    try {
      let userInfo = await Auth.currentAuthenticatedUser();
      const fetch = await createApolloFetch({
        uri: CONFIG.ApiUrl + "/public/graphql",
      });
      await fetch.use(({ request, options }, next) => {
        if (!options.headers) {
          options.headers = {};
        }
        let username = localStorage.getItem('username');
        if (!username || username === 'undefined')
          username = '';
        console.log('username=>', username);
        options.headers["authorization"] =
          userInfo.signInUserSession.idToken.jwtToken;
        options.headers["X-Api-Key"] = username;
        next();
      });
      let res = await fetch({
        query: `query verifyProfessionRights($condition:VerifyUserRightsInput!) {  
          verifyProfessionRights(condition:$condition) {
            status,
            message,
            profession_user_rights
                    }
                    }`,
        variables: {
          condition: {
            apn_type: apn_type
          }
        }
      });




      console.log("verifyProfessionRights ", res)
      if (res && res.data && res.data.verifyProfessionRights && res.data.verifyProfessionRights.status == 'success' && res.data.verifyProfessionRights.profession_user_rights) {
        return res.data.verifyProfessionRights;
      } else {
        console.log("You are not allowed to submit error");
        return false;
      }


    } catch (e) {
      return false;
      console.log("error occured", e);
    }

    // console.log('this.stata==>',this.state)
  }


  async onServiceClick(apn_type, user_profession_license, profession_user_rights) {
    console.log('onServiceClick', user_profession_license, profession_user_rights)
    console.log('apn_type', apn_type)

    let profession_license = localStorage.getItem('profession') ? JSON.parse(localStorage.getItem('profession')) : null;
    profession_license = profession_license != null ? profession_license.loggedUserInfoView && profession_license.loggedUserInfoView.profession[0] : null;
    user_profession_license = profession_license ? profession_license : user_profession_license;
    console.log('sidemenu onServiceClick', user_profession_license);

    // this.verifyUserRights();
    //possible call the graphql and allow the user to submit the application - check the user rights
    let verifyRightResult = await await this.verifyUserRights(apn_type);
    // if (await this.verifyUserRights()) {

    profession_user_rights = verifyRightResult.profession_user_rights;

    console.log('verifyUserRights true ', profession_user_rights)

    switch (apn_type) {
      case '500':
        this.props.history.push({ pathname: '/professional/goodstanding', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '400':
        this.props.history.push({ pathname: '/professional/visitingconsultant', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '200':
        this.props.history.push({ pathname: '/professional/recategorization', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '150':

        // let profesion_rights = {
        //   allow_renewal_license: true
        // }
        // this.props.history.push({
        //   pathname: '/professional/renewal', state: {
        //     apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register,
        //     profession_user_rights: profesion_rights
        //   }
        // });
        this.props.history.push({ pathname: '/professional/renewal', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '350':
        this.props.history.push({ pathname: '/professional/others/surgicalprocedure', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '300':
        this.props.history.push({ pathname: '/professional/others/parttime', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '250':
        this.props.history.push({ pathname: '/professional/others/transferlicense', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '501':
      this.props.history.push({ pathname: '/professional/combinedservices', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
      break;
      case '502':
        this.props.history.push({ pathname: '/professional/pharmacymanager', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '504':
        this.props.history.push({ pathname: '/professional/hajpermit', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '505':
        this.props.history.push({ pathname: '/professional/premaritalpermit', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '506':
        this.props.history.push({ pathname: '/professional/updatecpd', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '507':
        this.props.history.push({ pathname: '/professional/requestletters', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '510':
        this.props.history.push({ pathname: '/professional/updatecontactinfo', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      case '511':
        this.props.history.push({ pathname: '/professional/telemedicine', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
        break;
      default:
        this.props.history.push({ pathname: '/professional/others', state: { apn_type, user_profession_license, is_back_office_profession_register: this.state.is_back_office_profession_register, profession_user_rights: profession_user_rights } });
    }
    // }
  }

  onManageProfileClick(user_profession_license) {
    console.log('onManageProfileClick', user_profession_license);
    this.props.history.push({ pathname: '/dashboard/profile', state: { user_profession_license } });
  }

   invitationClick(user_profession_license) {
    console.log('invitation', user_profession_license);
    this.props.history.push({ pathname: '/invitation', state: { user_profession_license } });
  }
  onUpdateContactDetailsClick(user_profession_license) {
    console.log('onUpdateContactDetailsClick', user_profession_license);
    this.props.history.push({ pathname: '/professional/updatecontactinfo', state: { user_profession_license } });
  }
  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  async onNewApplicationClick(user_profession_license, profession_user_rights) {
    let verifyRightResult = await await this.verifyUserRights('100');
    profession_user_rights = verifyRightResult.profession_user_rights;
    this.props.history.push({ pathname: '/professional', state: { user_profession_license, profession_user_rights: profession_user_rights } });
  }


  sideNavMenuWrongUserName() {
    return (
      <List component="nav" aria-label="main mailbox folders">
        <ListItem button component="a" href="/dashboard/profession" style={window.location.pathname === "/dashboard/profession" || window.location.pathname === "/dashboard" || window.location.pathname === "/" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.Grid size={18} style={window.location.pathname === "/dashboard/profession" || window.location.pathname === "/dashboard" || window.location.pathname === "/" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "/dashboard/profession" || window.location.pathname === "/dashboard" || window.location.pathname === "/" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Dashboard</Typography>} />
        </ListItem>
        <ListItem button component="a" href="/" onClick={this.handleLogout} >
          <ListItemIcon>
            <Icon.LogOut size={18} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body1" style={{ color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }} >Logout</Typography>} />
        </ListItem>
      </List>);
  }
  sideNavMenu(user_profession_license, profession_user_rights) {
    return (
      <List component="nav" aria-label="main mailbox folders">
        <ListItem button component="a" href="/dashboard/profession" style={window.location.pathname === "/dashboard/profession" || window.location.pathname === "/dashboard" || window.location.pathname === "/" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.Grid size={18} style={window.location.pathname === "/dashboard/profession" || window.location.pathname === "/dashboard" || window.location.pathname === "/" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "/dashboard/profession" || window.location.pathname === "/dashboard" || window.location.pathname === "/" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Dashboard</Typography>} />
        </ListItem>

        <ListItem button onClick={this.handleClick}>
          <ListItemIcon>
            <Icon.BookOpen color="#318fa9" size={18} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={{ color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Professional Services</Typography>} />
          {this.state.open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={this.state.open} timeout="auto" unmountOnExit style={{ paddingLeft: 35 }}>

          <List component="div" disablePadding>

            <ListItem button component="a" onClick={() => {
              this.onNewApplicationClick(user_profession_license, profession_user_rights)
            }} style={window.location.pathname === '/professional' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>New Application</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '150', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/renewal' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/renewal' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/renewal" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Renewal of License</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '200', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/recategorization' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/recategorization' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/recategorization" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>License ReCategorization</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '350', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/others/surgicalprocedure' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/others/surgicalprocedure' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/others/surgicalprocedure" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Surgical Procedure</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '300', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/others/parttime' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/others/parttime' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/others/parttime" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Part-Time Practice</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '250', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/others/transferlicense' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/others/transferlicense' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/others/transferlicense" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Transfer of License</Typography>} />
            </ListItem>
            {//process.env.REACT_APP_HOST_ENV !== 'production' &&
              <ListItem button component="a" onClick={this.onServiceClick.bind(this, '400', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/visitingconsultant' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
                <ListItemIcon>
                  <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/visitingconsultant' ? { color: '#fff' } : { color: '#318fa9' }} />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/visitingconsultant" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Visiting Consultant</Typography>} />
              </ListItem>
            }
            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '500', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/goodstanding' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/goodstanding' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/goodstanding" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Good Standing Certificate</Typography>} />
            </ListItem>
            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '504', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/hajpermit' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/hajpermit' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/hajpermit" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Haj Permit</Typography>} />
            </ListItem>

            {/* <ListItem button onClick={this.onUpdateContactDetailsClick.bind(this, user_profession_license,profession_user_rights)} style={window.location.pathname === "/dashboard/profile/updatedetails" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} style={window.location.pathname === "/dashboard/profile/updatedetails" ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/dashboard/profile/updatedetails" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Update Contact Information</Typography>} />
            </ListItem> */}
            <ListItem button  component="a" onClick={this.onServiceClick.bind(this, '501', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/combinedservices' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/combinedservices' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/combinedservices" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Combined Services</Typography>} />
            </ListItem>
            {/* <ListItem button component="a" onClick={this.onServiceClick.bind(this, '502', user_profession_license,profession_user_rights)} style={window.location.pathname === '/professional/pharmacymanager' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/pharmacymanager' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/pharmacymanager" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Assigning of Medical Director</Typography>} />
            </ListItem> */}



            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '505', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/premaritalpermit' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/premaritalpermit' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/premaritalpermit" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Pre-Marital Permit</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '506', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/updatecpd' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/updatecpd' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/updatecpd" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Update CPD</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '507', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/requestletters' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/requestletters' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/requestletters" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Request Official Letters</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '510', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/updatecontactinfo' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional/updatecontactinfo' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional/updatecontactinfo" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Update Contact Information</Typography>} />
            </ListItem>

            <ListItem button component="a" onClick={this.onServiceClick.bind(this, '511', user_profession_license, profession_user_rights)} style={window.location.pathname === '/professional/telemedicine' ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
              <ListItemIcon>
                <Icon.Circle size={12} strokeWidth={6} style={window.location.pathname === '/professional' ? { color: '#fff' } : { color: '#318fa9' }} />
              </ListItemIcon>
              <ListItemText primary={<Typography variant="body1" style={window.location.pathname === "/professional" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Telemedicine</Typography>} />
            </ListItem>

          </List>
        </Collapse >

        <ListItem button component="a" href="/pharmaceutical" disabled style={window.location.pathname === "/pharmaceutical" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.Activity size={18} style={window.location.pathname === "/dashboard/facility" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "/dashboard/facility" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Pharmaceutical</Typography>} />
        </ListItem>

        <ListItem button component="a" href="/devices" disabled style={window.location.pathname === "/devices" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.Tablet size={18} style={window.location.pathname === "/devices" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "/devices" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Devices</Typography>} />
        </ListItem>

        <ListItem button component="a" onClick={this.invitationClick.bind(this, user_profession_license, profession_user_rights)} style={window.location.pathname === "/invitation" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.UserPlus size={18} style={window.location.pathname === "/invitation" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "/invitation" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Invitations</Typography>} />
        </ListItem>

        <ListItem button component="a" onClick={this.onManageProfileClick.bind(this, user_profession_license, profession_user_rights)} style={window.location.pathname === "/dashboard/profile" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.Settings size={18} style={window.location.pathname === "/dashboard/profile" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "/dashboard/profile" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Manage Profile</Typography>} />
        </ListItem>


        <ListItem button component="a" href="https://www.nhra.bh/Departments/HCF/Policies/Policies.aspx" style={window.location.pathname === "https://www.nhra.bh/Departments/HCF/Policies/Policies.aspx" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.FilePlus size={18} style={window.location.pathname === "https://www.nhra.bh/Departments/HCF/Policies/Policies.aspx" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "https://www.nhra.bh/Departments/HCF/Policies/Policies.aspx" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Policies</Typography>} />
        </ListItem>

        <ListItem button component="a" href="https://www.nhra.bh/Departments/CPD/ct/Regulation/Clinical%20Trials%20Regulations.aspx" style={window.location.pathname === "https://www.nhra.bh/Departments/CPD/ct/Regulation/Clinical%20Trials%20Regulations.aspx" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.Clipboard size={18} style={window.location.pathname === "https://www.nhra.bh/Departments/CPD/ct/Regulation/Clinical%20Trials%20Regulations.aspx" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "https://www.nhra.bh/Departments/CPD/ct/Regulation/Clinical%20Trials%20Regulations.aspx" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Regulation</Typography>} />
        </ListItem>

        <ListItem button component="a" href="https://www.nhra.bh/Departments/HCF/Guidelines/Guidelines.aspx" style={window.location.pathname === "https://www.nhra.bh/Departments/HCF/Guidelines/Guidelines.aspx" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.BookOpen size={18} style={window.location.pathname === "https://www.nhra.bh/Departments/HCF/Guidelines/Guidelines.aspx" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "https://www.nhra.bh/Departments/HCF/Guidelines/Guidelines.aspx" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Guidelines</Typography>} />
        </ListItem>

        <ListItem button component="a" href="https://www.nhra.bh/Departments/MDR/Useful%20Resources/Useful%20links/Useful%20links.aspx" style={window.location.pathname === "https://www.nhra.bh/Departments/MDR/Useful%20Resources/Useful%20links/Useful%20links.aspx" ? { backgroundColor: '#318fa9' } : { backgroundColor: '#fff' }}>
          <ListItemIcon>
            <Icon.MousePointer size={18} style={window.location.pathname === "https://www.nhra.bh/Departments/MDR/Useful%20Resources/Useful%20links/Useful%20links.aspx" ? { color: '#fff' } : { color: '#318fa9' }} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body2" style={window.location.pathname === "https://www.nhra.bh/Departments/MDR/Useful%20Resources/Useful%20links/Useful%20links.aspx" ? { color: '#fff', fontFamily: 'Roboto', fontWeight: 'bold' } : { color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }}>Useful Links</Typography>} />
        </ListItem>

        <ListItem button component="a" href="/" onClick={this.handleLogout} >
          <ListItemIcon>
            <Icon.LogOut size={18} />
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body1" style={{ color: '#111', fontFamily: 'Roboto', fontWeight: 'bold' }} >Logout</Typography>} />
        </ListItem>

      </List >)
  }
  render() {
    let profession_license = localStorage.getItem('profession') ? JSON.parse(localStorage.getItem('profession')) : null;
    console.log('sidemenu profession_license', profession_license);
    let user_profession_license = profession_license != null ? profession_license.loggedUserInfoView && profession_license.loggedUserInfoView.profession[0] : null;

    if (this.state.user_name && this.state.user_name != 'superadmin' && user_profession_license
      && user_profession_license.cpr_number && user_profession_license.cpr_number != ''
      && user_profession_license.cpr_number != this.state.user_name) {
      return (this.sideNavMenuWrongUserName());
    } else {
      return this.sideNavMenu(user_profession_license, null)
    }

    // return (
    // <Query query={DASHBOARD_QUERY.USER_INFO_GQL} variables={{ condition: {} }}>
    //   {({ loading: user_loading, error: user_error, data: user_data }) => {
    //     if (user_loading) {
    //       return (<Grid container   >
    //         <Grid item xs={12}>
    //           <Grid
    //             container
    //             spacing={16}

    //             alignItems='center'
    //             direction='row'
    //             justify='center'>
    //             <Grid item xs={12} className="progress-grid-row-class">

    //               <CircularProgress size={60} >
    //                 {this.sideNavMenu(user_profession_license,
    //                   profession_user_rights)
    //                 }
    //               </CircularProgress>
    //             </Grid>
    //           </Grid>
    //         </Grid>
    //       </Grid>);
    //     }
    //     console.log(user_data);
    //     var user_profession_license = null;
    //     var profession_user_rights = null;
    //     if (user_data && user_data.loggedUserInfoView && user_data.loggedUserInfoView.profession && user_data.loggedUserInfoView.profession.length > 0) {
    //       user_profession_license = user_data.loggedUserInfoView.profession[0];

    //     }
    //     // if (this.state.is_back_office_profession_register) {
    //     //   disable_partime = false;
    //     //   disable_surgery = false;
    //     //   disable_transfer = false;
    //     //   disable_renewal = false;
    //     //   disable_recategorization = false;
    //     //   disable_visiting_consultant = false;
    //     //   disable_goodstanding = false;
    //     //   disable_manage_profile = false;
    //     // }

    //     // else
    //     if (user_data && user_data?.loggedUserInfoView && user_data.loggedUserInfoView.profession_user_rights) {
    //       // disable_newapplication = user_data.loggedUserInfoView.profession.length > 0 ? true : false;
    //       // disable_partime = JSON.parse(user_data.loggedUserInfoView.profession_user_rights.allow_partime_practice) ? false : true;
    //       // disable_surgery = JSON.parse(user_data.loggedUserInfoView.profession_user_rights.allow_surgical_procedure) ? false : true;
    //       // disable_transfer = JSON.parse(user_data.loggedUserInfoView.profession_user_rights.allow_transfer_license) ? false : true;
    //       // disable_renewal = JSON.parse(user_data.loggedUserInfoView.profession_user_rights.allow_renewal_license) ? false : true;
    //       // disable_recategorization = JSON.parse(user_data.loggedUserInfoView.profession_user_rights.allow_re_categorization) ? false : true;
    //       // disable_visiting_consultant = false
    //       // disable_goodstanding = JSON.parse(user_data.loggedUserInfoView.profession_user_rights.allow_good_standing_certificate) ? false : true;
    //       // disable_manage_profile = user_data.loggedUserInfoView.profession.length > 0 ? false : true;
    //       profession_user_rights = user_data.loggedUserInfoView.profession_user_rights
    //     }
    //     localStorage.setItem('profession', JSON.stringify(user_data?.loggedUserInfoView?.profession));
    //     if (this.state.user_name && this.state.user_name != 'superadmin' && user_profession_license
    //       && user_profession_license.cpr_number && user_profession_license.cpr_number != ''
    //       && user_profession_license.cpr_number != this.state.user_name)
    //       return (this.sideNavMenuWrongUserName());
    //     return (
    //       this.sideNavMenu(user_profession_license, profession_user_rights)
    //     );
    //   }}
    // </Query>
    // )
  }
}
export default withRouter(Sidemenu)